import { render, staticRenderFns } from "./SearchProtocol.vue?vue&type=template&id=6afd52ec&"
import script from "./SearchProtocol.vue?vue&type=script&lang=js&"
export * from "./SearchProtocol.vue?vue&type=script&lang=js&"
import style0 from "./SearchProtocol.vue?vue&type=style&index=0&id=6afd52ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports